<template>
  <div
    class="pill"
    :class="{
      [`pill--${status}`]: status
    }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: "Pill",

  props: {
    status: {
      type: String,
      default: "success",
      validator: value => {
        return ["success", "warning", "danger", "secondary", "tertiary"].includes(value)
      }
    }
  }
}
</script>

<style scoped>
.pill {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  color: var(--color-neutral-00);
  font-family: Roboto;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 12px;
}

.pill.pill--success {
  background-color: var(--color-success-50);
}

.pill.pill--warning {
  background-color: var(--color-warning-50);
}

.pill.pill--danger {
  background-color: var(--color-error-50);
}

.pill.pill--secondary {
  background-color: var(--color-neutral-10);
  color: var(--color-neutral-80);
}

.pill.pill--tertiary {
  background-color: var(--color-neutral-70);
  color: var(--color-neutral-00);
}
</style>
